/**
 * @generated SignedSource<<66da1f47ac8487a702a589471233c0da>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type UserInterfaceSwitchType = "FULL_SWITCH" | "NO_RETURN_SWITCH" | "NO_SWITCH";
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
import { FragmentRefs } from "relay-runtime";
export type usetifulFragment$data = {
  readonly isSellerMigrating: boolean;
  readonly salesChannels: ReadonlyArray<{
    readonly detail: {
      readonly id: string;
      readonly properties: {
        readonly name: string | null;
      } | null;
    } | null;
    readonly ecommerceSettings: {
      readonly definitiveUrl: string | null;
      readonly ecommerceGlobalID: string;
      readonly ecommerceName: ECommerce;
      readonly id: string;
      readonly isMarketplace: boolean;
      readonly remoteUrl: string | null;
    } | null;
    readonly id: string;
  }>;
  readonly sellerSetting: {
    readonly userInterfaceSwitchType: UserInterfaceSwitchType;
  };
  readonly sellerUserInterfaces: {
    readonly nodes: ReadonlyArray<{
      readonly environment: ZakekeEnvironment;
      readonly id: string;
      readonly isDefault: boolean;
      readonly sellerUserInterfaceId: number;
      readonly settings: string | null;
      readonly url: string | null;
      readonly userInterfaceId: number | null;
    } | null> | null;
  } | null;
  readonly shopifyAuthEcommerceSettings: {
    readonly environment: ZakekeEnvironment;
    readonly installed: boolean;
    readonly isTestStore: boolean;
    readonly shop: string | null;
  } | null;
  readonly treeMenuReferringInfo: {
    readonly isSubscriptionSubStatusBlocked: boolean;
    readonly isTrial: boolean;
    readonly noValidSubscriptionReason: string | null;
    readonly subscriptionCancel: string | null;
  };
  readonly " $fragmentType": "usetifulFragment";
};
export type usetifulFragment$key = {
  readonly " $data"?: usetifulFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"usetifulFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "environment",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "usetifulFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSellerMigrating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreeMenuReferringInfo",
      "kind": "LinkedField",
      "name": "treeMenuReferringInfo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSubscriptionSubStatusBlocked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noValidSubscriptionReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subscriptionCancel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTrial",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerSetting",
      "kind": "LinkedField",
      "name": "sellerSetting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userInterfaceSwitchType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 50
        }
      ],
      "concreteType": "SellerUserInterfacesConnection",
      "kind": "LinkedField",
      "name": "sellerUserInterfaces",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerUserInterface",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "settings",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isDefault",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "userInterfaceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "sellerUserInterfaceId",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "sellerUserInterfaces(first:50)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShopifyAuthEcommerceSettings",
      "kind": "LinkedField",
      "name": "shopifyAuthEcommerceSettings",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "installed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTestStore",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shop",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "ACTIVE"
        }
      ],
      "concreteType": "SalesChannel",
      "kind": "LinkedField",
      "name": "salesChannels",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesChannelDetail",
          "kind": "LinkedField",
          "name": "detail",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "SalesChannelDetailProperties",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EcommerceSettings",
          "kind": "LinkedField",
          "name": "ecommerceSettings",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceGlobalID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remoteUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMarketplace",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "definitiveUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "salesChannels(status:\"ACTIVE\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "0c62d872c26d5cb65b89c92c6a06d394";

export default node;
